import { createTheme, type PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#1A1A1A" },
            secondary: { main: "#0066FF" },
            success: { main: "#10B981" },
            error: { main: "#EF4444" },
            background: { default: "#F3F4F6", paper: "#FFFFFF" },
          }
        : {
            primary: { main: "#E0E0E0" },
            secondary: { main: "#4A8BFF" },
            success: { main: "#34D399" },
            error: { main: "#EF5350" },
            background: { default: "#121212", paper: "#1E1E1E" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 9999,
            fontWeight: 500,
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 24,
            border: "1px solid",
            borderColor: mode === "light" ? "#F0F0F0" : "#333",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            "&.Mui-selected": {
              backgroundColor: mode === "light" ? "#FFFFFF" : "#2A2A2A",
              boxShadow: mode === "light" ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
              "&:hover": {
                backgroundColor: mode === "light" ? "#F9FAFB" : "#333",
              },
            },
          },
        },
      },
    },
  });
}
